import { render, staticRenderFns } from "./QuotationApproval.vue?vue&type=template&id=1a1b69ec"
import script from "./QuotationApproval.vue?vue&type=script&lang=js"
export * from "./QuotationApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports